import React, {memo} from "react";
import {NodeProps} from "@xyflow/react";
import {Metric, TreeNode} from "@/types";
import {BasicCardNode, get_color, render_line} from "@/pages/mindmap/CarNodes/BasicCardNode.tsx";
import {formatCompactNumber, formatPercentage} from "@/utils/format.ts";
import {COLOR_MAP} from "@/pages/mindmap/constant.ts";


export const ProvinceNode = memo(({data}: NodeProps) => {
    const node: TreeNode = data.node as any;
    const datas: Record<string, Metric> = node.metrics_map || {};

    const render_desc = () => {
        if (node.id.includes("-vbp-")) {
            const list_datas = ['_1', '_2', '_3']
                .filter((rank) => `vbp_batch_name${rank}` in datas)
                .filter((rank) => (`actual_cycle_month${rank}` in datas && datas[`actual_cycle_month${rank}`].value != 0 && datas[`actual_cycle_month${rank}`].value != null))
                .map((rank) => ({
                    batch: datas[`vbp_batch_name${rank}`].display ,
                    batch_color: get_color(`vbp_batch_name${rank}`, datas),
                    cycle_month: datas[`actual_cycle_month${rank}`]?.value,
                    cycle_month_color: get_color(`actual_cycle_month${rank}`, datas),
                    fulfill: formatPercentage(datas[`fulfillment_achi${rank}`]?.value),
                    fulfill_color: COLOR_MAP['1']
                }))
                .sort((a, b) => {
                    const a_data = a.cycle_month || 0
                    const b_data = b.cycle_month || 0
                    return a_data - b_data
                })

            return <>
                {render_line('ims_vbp', 'mtd', datas, false, 'auto')}
                <br/>
                Batch Performance:<br/>
                {list_datas.map((rank) => (
                        <div>
                        <span style={rank.batch_color}>
                        {rank.batch || '--'}
                        </span>
                            ,&nbsp;Cycle Month&nbsp;
                        <span style={rank.cycle_month_color}>
                            {rank.cycle_month || '--'}
                        </span>
                            ,&nbsp;Contract Fulfill%&nbsp;
                        <span style={rank.fulfill_color}>
                            {rank.fulfill || '--'}
                        </span>
                        </div>
                    ))}
            </>
        }
        if (node.id.includes("-nonvbp-")) {
            return render_line('ims_nonvbp', 'mtd', datas, false, 'auto')
        }

        return render_line('ims', 'mtd', datas, false, 'auto')
    }

    return <BasicCardNode node={node} showChart={true} data={data}>
        <div style={{marginLeft: '0px'}}>
            {render_desc()}
        </div>
    </BasicCardNode>
})